import { render, staticRenderFns } from "./FactcheckArticleCard.vue?vue&type=template&id=3f590f4c"
import script from "./FactcheckArticleCard.vue?vue&type=script&lang=ts"
export * from "./FactcheckArticleCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports